import React from "react";

type TextWithLinksProps = {
    text: string;
};

export const TextWithLinks: React.FC<TextWithLinksProps> = ({ text }) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return (
        <p>
            {parts.map((part, index) =>
                urlRegex.test(part) ? (
                    <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                    >
                        {part}
                    </a>
                ) : (
                    <span key={index}>{part}</span>
                )
            )}
        </p>
    );
};
